import { Select, svgIconClasses, inputClasses, MenuItem, menuItemClasses, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledSelect = styled(Select)(({ theme }) => ({
  ...theme.typography["Lato Emphasized 2"],
  [`& .${svgIconClasses.root}`]: {
    fontSize: "18px",
    top: "2px"
  },
  [`& .${inputClasses.input}`]: {
    maxWidth: "150px",
    minWidth: "0 !important",
    whiteSpace: "initial",
    paddingTop: 0,
    "& > svg": {
      display: "none"
    },
    "&:focus": {
      background: "transparent"
    }
  }
}));
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  ...theme.typography["Lato Emphasized 2"],
  padding: "14px 16px 14px 8px",
  background: theme.palette.common.white,
  "&:hover": {
    background: theme.palette.primary["50"]
  },
  [`&.${menuItemClasses.selected}`]: {
    background: theme.palette.common.white,
    "&:hover": {
      background: theme.palette.primary["50"]
    }
  }
}));
const PatientLink = styled(Link)(({ theme }) => ({
  color: theme.palette.grey[800],
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: "20px",
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline"
  }
}));
export {
  PatientLink,
  StyledMenuItem,
  StyledSelect
};
